import { getToken } from "firebase/messaging";
import { messaging } from "../firebase";
import masterApi from "../apis/master.api.js";

export const requestPermission = async (userId, handleLoading = () => {}) => {
  try {
    console.log("requestPermission userId:",userId)
    // 1️⃣ Ask browser permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission denied");
      return;
    }

    // 2️⃣ Register service worker
    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );
    console.log("Service Worker registered:", registration);

    // 3️⃣ Get FCM token
    const token = await getToken(messaging, {
      vapidKey: "BMo02YcnmQse0hSsElAGS5uhoCqqklji5twX8Yv9YK8mGZab3BK68wnkFso0Re6Rfl8uzuLiFYc0sfmIfLkPJWk",
    });

    if (!token) {
      console.log("No FCM token generated");
      return;
    }

    // 4️⃣ Save token in backend
    handleLoading(true);
    const payload = {
      user_id: userId,
      fcm_token: token,
      device_type: "web",
    };

    const res = await masterApi.saveFcmToken(payload);
    console.log("FCM token saved:", res.data);
  } catch (error) {
    console.error("FCM error:", error);
  } finally {
    handleLoading(false);
  }
};
